module.exports = __webpack_public_path__ + "static/media/email-icon.f209341b.png";